import { SVGProps } from 'react';
export const BellButtonIconOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.14 2.408a1.44 1.44 0 1 0-2.133 0h-.014c-2.463.405-4.32 2.53-4.32 5.062v1.148c0 1.518-.54 3.003-1.485 4.218l-.506.608a.838.838 0 0 0-.101.877c.135.27.405.439.743.439h13.5a.787.787 0 0 0 .708-.439.838.838 0 0 0-.101-.877l-.506-.608a6.871 6.871 0 0 1-1.452-4.218V7.47c0-2.531-1.89-4.657-4.32-5.062h-.013ZM8.803 3.96h.54a3.529 3.529 0 0 1 3.51 3.51v1.148c0 1.62.44 3.172 1.317 4.522H3.943a8.26 8.26 0 0 0 1.35-4.522V7.47a3.507 3.507 0 0 1 3.51-3.51Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10.592 17.392c.405-.404.641-.978.641-1.552h-4.32c0 .574.203 1.148.608 1.552.405.405.979.608 1.552.608.574 0 1.114-.203 1.52-.608Z"
    />
  </svg>
);
